import * as React from 'react'

import { auto } from '@cloudinary/url-gen/actions/resize'
import { useRecoilValue } from 'recoil'

import fillUrlWithValues from '../../../misc/helpers/fillUrlWithValues'
import routes from '../../../router/routes'
import { cld } from '../../../services/CloudinaryService'
import { translate } from '../../../state/locale/selectors/translate'
import { Link } from '../../reusable/Link'
import styles from './Sponsorships.module.scss'
import { ISponsorshipsProps } from './Sponsorships.types'

export const Sponsorships = ({ data }: ISponsorshipsProps) => {
  const i18n = useRecoilValue(translate).sponsorship

  return (
    <>
      <h2 className={styles.pageTitle}>{i18n.title}</h2>
      {/*<p className={styles.paragraph}>{lang.description}</p>*/}
      <div className={styles.sponsorshipWrapper}>
        {data.map((department) => {
          const imageUrl = cld
            .image(department.image.provider_metadata.public_id)
            .format('auto')
            .quality('auto')
            .resize(auto().width(500).height(500))
            .toURL()

          return (
            <Link
              className={styles.column}
              to={fillUrlWithValues(routes.sponsorship, ':slug', department.slug)}
              key={department.id}
            >
              <div className={styles.columnHeader}>
                <img className={styles.cover} src={imageUrl} alt={department.title} />
              </div>
              <div className={styles.columnBody}>
                <h3 className={styles.columnTitle}>{department.title}</h3>
                <p className={styles.paragraph}>{department.description}</p>
              </div>
            </Link>
          )
        })}
      </div>
    </>
  )
}
